<div class="alert alert-primary" role="alert" *ngIf="selected_special_service">
  We are operating <strong>modified service</strong> on this day. Make sure to check our service alerts and advisories
  for other changes in service.
</div>

<table class="table table-bordered">
  <ng-container *ngIf="stop_times != null">
    <thead>
      <tr>
        <th scope="col">Block <span class="text-secondary text-last-at">vehicle</span></th>
        <th scope="col">Destination</th>
        <th scope="col">Departure</th>
      </tr>
    </thead>
  </ng-container>
  <tbody>
    <ng-container *ngFor="let times of stop_times">
      <ng-container
        *ngIf="(times.actual_arrival_time >= current_date || (times.next_stop_sequence <= times.stop_sequence && times.next_stop_sequence != null) ) && times.direction_id == selected_direction">
        <tr>
          <td><a routerLink="/schedule/trip/{{times.actual_trip_id }}">{{ times.block_id }}</a>
            <div class="text-secondary text-last-at">{{times.vehicle_id}}</div>
          </td>
          <td>{{ times.trip_headsign }}</td>
          <td> {{ times.arrival_time }}
            <ng-container *ngIf="times.delay == -900">
              <span class="badge badge-secondary">{{times.status}}</span>
            </ng-container>
            <ng-container *ngIf="times.delay < 1 && times.delay > -900">
              <span class="badge badge-success">{{times.status}}</span>
            </ng-container>
            <ng-container *ngIf="times.delay >= 1 && times.delay < 900">
              <span class="badge badge-warning">{{times.status}}</span>
            </ng-container>
            <ng-container *ngIf="times.delay == 999">
              <span class="badge badge-danger">{{times.status}}</span>
            </ng-container>
            <ng-container *ngIf="times.delay == 998">
              <span class="badge badge-warning">{{times.status}}</span>
            </ng-container>
            <ng-container *ngIf="times.next_stop_name != null && times.next_stop_name != ''">
              <div class="text-secondary text-last-at">Next stop {{times.next_stop_name}}</div>
            </ng-container>
          </td>
        </tr>
      </ng-container>
    </ng-container>
  </tbody>
</table>